import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FolderContainer } from "globalComponents";
import JoinRequests from "pages/joinRequests/index.jsx";
import Settings from "./Settings";

// Company page: settings plus join requests. Open to manageCompany or
// manageJoinRequests (super always); each tab needs its own permission.
const Company = () => {
  const user = useSelector((state) => state.current.user);
  const permissions = useSelector((state) => state.current.permissions) || [];
  const { search } = useLocation();
  const isSuper = user?.accountType === "super";
  const canSettings = isSuper || permissions.includes("manageCompany") || permissions.includes("manageJoinRequests");
  const canRequests = isSuper || permissions.includes("manageJoinRequests");

  const tabs = [
    ...(canSettings ? ["Settings"] : []),
    ...(canRequests ? ["Join Requests", "History"] : []),
  ];
  // /company?tab=requests opens the requests (old /join-requests links)
  const wanted = new URLSearchParams(search).get("tab") === "requests" ? "Join Requests" : null;
  const [picked, setPicked] = useState(null);
  // permissions can load after the first render (opening /company directly),
  // so the selected tab is worked out each render
  const tab = tabs.includes(picked) ? picked : tabs.includes(wanted) ? wanted : tabs[0];

  if (!user?._id) return null; // still loading who this is
  if (!tabs.length)
    return (
      <FolderContainer title="Company">
        <p>You need the manageCompany or manageJoinRequests permission to see this page.</p>
      </FolderContainer>
    );

  return (
    <FolderContainer tabs={tabs} selectedTab={tab} onTab={setPicked}>
      {tab === "Settings" && <Settings />}
      {tab === "Join Requests" && <JoinRequests key="pending" tab="Pending" />}
      {tab === "History" && <JoinRequests key="history" tab="History" />}
    </FolderContainer>
  );
};

export default Company;
